import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail } from "lucide-react";
import { ASSETS, CONTACT_EMAIL } from "../../data/site";
import { StoreBadges } from "./StoreBadges";

const SOCIALS = [
  { label: "Instagram", icon: Instagram, href: "https://www.instagram.com/sistersafe.app" },
  { label: "Facebook", icon: Facebook, href: "https://www.facebook.com/SisterSafeApp" },
];

export const Footer = () => (
  <footer className="border-t border-[#E8EBE9] bg-[#FBFBF9]" data-testid="footer">
    <div className="mx-auto max-w-7xl px-6 py-16 md:px-12">
      <div className="flex flex-col justify-between gap-10 md:flex-row md:items-start">
        <div className="max-w-sm">
          <Link to="/" className="flex items-center gap-2.5" data-testid="footer-logo">
            <img src={ASSETS.logoIcon} alt="SisterSafe" className="h-9 w-9 object-contain" />
            <span className="font-heading text-xl font-semibold tracking-tight text-[#111E16]">
              SisterSafe
            </span>
          </Link>
          <p className="mt-4 leading-relaxed text-[#4A5F52]">
            A women-first safety network rooted in confidence, preparedness, and community.
          </p>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="mt-5 inline-flex items-center gap-2 text-[#2F5E43] transition-colors hover:text-[#244A34]"
            data-testid="footer-email"
          >
            <Mail className="h-4 w-4" />
            {CONTACT_EMAIL}
          </a>
          <div className="mt-6 flex gap-3">
            {SOCIALS.map((s) => {
              const Icon = s.icon;
              return (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-[#E8EBE9] bg-white text-[#2F5E43] transition-colors hover:bg-[#2F5E43] hover:text-white"
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                >
                  <Icon className="h-5 w-5" />
                </a>
              );
            })}
          </div>
          <StoreBadges testPrefix="footer" className="mt-8" />
        </div>

        <div className="grid grid-cols-2 gap-12 sm:grid-cols-3">
          <div>
            <p className="font-heading text-sm font-semibold uppercase tracking-wider text-[#8AA583]">
              Product
            </p>
            <ul className="mt-4 space-y-3 text-[#4A5F52]">
              <li><a href="/#features" className="transition-colors hover:text-[#2F5E43]">Features</a></li>
              <li><a href="/#how-it-works" className="transition-colors hover:text-[#2F5E43]">How it works</a></li>
              <li><a href="/#privacy" className="transition-colors hover:text-[#2F5E43]">Privacy</a></li>
            </ul>
          </div>
          <div>
            <p className="font-heading text-sm font-semibold uppercase tracking-wider text-[#8AA583]">
              Company
            </p>
            <ul className="mt-4 space-y-3 text-[#4A5F52]">
              <li><a href="/#faq" className="transition-colors hover:text-[#2F5E43]">FAQ</a></li>
              <li><Link to="/contact" className="transition-colors hover:text-[#2F5E43]" data-testid="footer-contact">Contact</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-heading text-sm font-semibold uppercase tracking-wider text-[#8AA583]">
              Legal
            </p>
            <ul className="mt-4 space-y-3 text-[#4A5F52]">
              <li><Link to="/privacy" className="transition-colors hover:text-[#2F5E43]" data-testid="footer-privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms" className="transition-colors hover:text-[#2F5E43]" data-testid="footer-terms">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-[#E8EBE9] pt-8 text-sm text-[#8AA583] sm:flex-row">
        <p>Copyright © {new Date().getFullYear()} SisterSafe. All rights reserved.</p>
        <p>Built with women in mind.</p>
      </div>
    </div>
  </footer>
);
